
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import Pagination from "@/components/common/Pagination.vue";

  import { RESET_SCROLL, RESTORE_SCROLL, SAVE_SCROLL } from "@/entities/Events";
  import PaginationConfig from "@/entities/PaginationConfig";

  @Component({
    components: {
      Pagination,
    },
  })
  export default class ResourceCardPagination extends Vue {
    @Prop({ type: Object, required: true }) readonly config!: PaginationConfig;

    get fromPageNumber(): number {
      return this.config.page * this.config.limit - this.config.limit + 1;
    }

    get toPageNumber(): number {
      return this.config.page * this.config.limit;
    }

    @Watch("config.page")
    onPageChange() {
      this.$eventBus.emit(RESET_SCROLL);
    }

    @Watch("config.loadedCount")
    onListItemsChanged() {
      if (this.config.page === 1) {
        this.$eventBus.emit(RESTORE_SCROLL);
      }
    }

    beforeDestroy() {
      this.$eventBus.emit(RESET_SCROLL);
    }

    prev(): void {
      if (this.config.page > 1) {
        this.$emit("update:config", { ...this.config, page: this.config.page - 1 });
      }
    }

    next(): void {
      this.$emit("update:config", { ...this.config, page: this.config.page + 1 });
    }

    updatedLimit(val: string) {
      this.$eventBus.emit(SAVE_SCROLL);
      const limit = parseInt(val);
      this.$emit("update:config", { ...this.config, limit, page: 1 });
    }
  }
